import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=439c6704&scoped=true"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=439c6704&prod&lang=scss&scoped=true"
import style1 from "./Delivery.vue?vue&type=style&index=1&id=439c6704&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439c6704",
  null
  
)

export default component.exports